// @ts-nocheck
import loadStoreList from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/LoadStoreList";
import { deleteCustomerFromStoreListApi } from "@store/Services/StoreListService";
import {
    createHandlerChainRunner,
    Handler,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{
    storeListId: string;
    storeListCustomerId: string;
    onSuccess?: () => void;
}>;

export const RequestRemoveCustomerFromStorelist: HandlerType = props => {
    return deleteCustomerFromStoreListApi({
        storeListId: props.parameter.storeListId,
        storeListCustomerId: props.parameter.storeListCustomerId,
    });
};

export const ResetStoreListsData: HandlerType = props => {
    props.dispatch({
        type: "Data/StoreListDetails/Reset",
    });
    props.dispatch({
        type: "Data/StoreLists/Reset",
    });
};

export const DispatchShipTosResetDataViews: HandlerType = props => {
    props.dispatch({
        type: "Data/ShipTos/ResetDataViews",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const DispatchLoadStoreList: HandlerType = props => {
    props.dispatch(loadStoreList({ storeListId: props.parameter.storeListId }));
};

export const chain = [
    RequestRemoveCustomerFromStorelist,
    ResetStoreListsData,
    DispatchShipTosResetDataViews,
    ExecuteOnSuccessCallback,
    DispatchLoadStoreList,
];

const deleteCustomerFromStoreList = createHandlerChainRunner(chain, "DeleteCustomerFromStoreList");
export default deleteCustomerFromStoreList;
